<app-navigation-layout [hideHeader]='true' [hideNavigation]="hideNavigation" [hideMenu]="true">
  <span main-container>
    <app-partner-code-login #partnerCodeLogin [allowGuestCardRegistration]="false" (back)="onBack()" (next)="forward()"
      (navigationVisibilityChange)=" onNavigationVisibilityChange(partnerCodeLogin.showNavigationBack)">
    </app-partner-code-login>
  </span>
  <span navigation-container>
    <app-backward-forward (backwardClick)="onBack()" [hideNext]="true">
    </app-backward-forward>
  </span>
</app-navigation-layout>
